module.exports = __webpack_public_path__ + "img/DE01231.bb97ab72.png";